import { useSpring, animated, config } from "@react-spring/three";
import { ScreenSpace } from "@react-three/drei";
import { NotEqualStencilFunc } from "three";
import { useSnapshot } from "valtio";
import store from "../../appStore";
import { useEffect } from "react";
import { useSynchronizedState } from "@solidwhite/multiuser";

const ViewBlocker = ({ ...props }) => {
  const { faded } = useSnapshot(store);

  const [synchFade, setSynchFade] = useSynchronizedState(`viewblockerfade`, false);

  useEffect(() => {
    setSynchFade(faded);
  }, [faded]);

  const { opacity } = useSpring({
    opacity: synchFade ? 1 : 0,
    config: synchFade ? config.default : config.molasses,
    delay: synchFade ? 0 : 200,
  });

  return (
    <ScreenSpace depth={1}>
      <mesh renderOrder={2} visible={true}>
        <planeGeometry args={[2, 2]} />
        <animated.meshBasicMaterial
          color="black"
          opacity={opacity}
          transparent
          depthTest={false}
          stencilFunc={NotEqualStencilFunc}
        />
      </mesh>
    </ScreenSpace>
  );
};

export default ViewBlocker;
